import React, { ReactNode, memo, useRef, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useHistory } from "react-router-dom";
import useOutsideAlerter from "../../../hook/outsideAlerter";
import { Container } from "./styles";

interface PanelAndDetailAndCreateHeaderProps {
  title: string;
  goBack?: boolean;
  handleGoBack?: () => void;
  updateAt?: string;

  children?: ReactNode;

  actions?: {
    label: string;
    icon?: React.ComponentType;
    onClick: () => void;
  }[];
}

const PanelAndDetailAndCreateHeaderComponent: React.FC<
  PanelAndDetailAndCreateHeaderProps
> = ({
  title,
  goBack = false,
  handleGoBack,
  updateAt,
  children,
  actions = [],
}) => {
  const outSideRef = useRef(null);
  const history = useHistory();

  const [isActions, setIsActions] = useState(false);

  useOutsideAlerter(outSideRef, () => {
    if (isActions) setIsActions(false);
  });

  return (
    <Container>
      <div style={{ display: "flex" }}>
        {(goBack || handleGoBack) && (
          <button
            type="button"
            onClick={() => {
              if (handleGoBack) {
                handleGoBack();
              } else {
                history.goBack();
              }
            }}
            className="arrowBack"
          >
            <FaArrowLeft size={18} />
          </button>
        )}

        <h2>{title}</h2>

        {children}
      </div>

      {actions.length > 1 && (
        <div className="actions-container" ref={outSideRef}>
          <button
            style={{
              background: "#fff",
              borderRadius: "6px",
              padding: "1rem",
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              fontWeight: "bold",
              border: "2px solid #ddd",
            }}
            type="button"
            onClick={() => setIsActions(!isActions)}
          >
            Mais ações <MdKeyboardArrowDown />
          </button>
          {isActions && (
            <div className="actions" onClick={() => setIsActions(false)}>
              {actions?.map((action, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={action.onClick}
                  className="actionButton"
                >
                  {action.icon && <action.icon />}
                  {action.label}
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      {updateAt && (
        <div className="infoUpdate">
          <span>Dados atualizados em {updateAt}</span>
        </div>
      )}
    </Container>
  );
};

export const PanelAndDetailAndCreateHeader = memo(
  PanelAndDetailAndCreateHeaderComponent,
  (oldData, newData) => {
    return (
      oldData.title === newData.title && oldData.updateAt === newData.updateAt
    );
  }
);
